import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Rating } from "@mui/material";
import { COLUMNS_EPISODS } from "../../constants/constants";
import { useState } from "react";

export default function StickyHeadTable({ rows = [] }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", bgcolor: "#2b2d42" }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {COLUMNS_EPISODS.map((column) => (
                <TableCell
                  sx={{ bgcolor: "#2B2D42", color: "white" }}
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ bgcolor: "#8d99ae" }}>
            {rows
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    {COLUMNS_EPISODS.map((column) => {
                      const value =
                        column.id === "name"
                          ? `${row.name} (Season ${row.season}, Episode ${row.number})`
                          : column.id === "rating"
                          ? row.rating.average
                          : row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.id === "index" &&
                            index + 1 + page * rowsPerPage}
                          {column.id === "rating" && (
                            <>
                              <Rating
                                sx={{
                                  top: "5px",
                                  display: { xs: "none", md: "inline-flex" },
                                }}
                                value={value}
                                max={10}
                                readOnly
                                precision={0.1}
                              />
                              {"  "}
                            </>
                          )}
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 50]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{ color: "white" }}
      />
    </Paper>
  );
}
